module.exports = __webpack_public_path__ + "img/5-5.d5ca7d92.svg";